import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import IconButton from '../IconButton/IconButton';

import './TranslationButtons.css';

const TranslationButtons = ({
  isTranslationLoading,
  isTranslated,
  isTranslatedError,
  handleTranslateButtonClick
}) => {
  const translatedOrError = isTranslatedError ? (
    <div styleName="translationWarning">{i18next.t('translationFailed')}</div>
  ) : (
    <IconButton
      label={
        isTranslated
          ? i18next.t('viewOriginalLanguage')
          : i18next.t('viewTranslation')
      }
      onClick={handleTranslateButtonClick}
    />
  );

  return (
    <div styleName="translate-container">
      {isTranslationLoading ? (
        <IconButton label={i18next.t('loading')} onClick={() => {}} isLoading />
      ) : (
        translatedOrError
      )}
    </div>
  );
};

TranslationButtons.propTypes = {
  handleTranslateButtonClick: PropTypes.func.isRequired,
  isTranslationLoading: PropTypes.bool.isRequired,
  isTranslated: PropTypes.bool.isRequired,
  isTranslatedError: PropTypes.bool.isRequired
};

export default TranslationButtons;
